import { useState } from 'react';
import { useFormik } from 'formik';
import { components } from 'react-select';

const useFilter = (initialFilters = {}, fetchDataFunction,validationSchema ,serverSort) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [limit, setLimit] = useState(100);
    const [totalRows, setTotalRows] = useState(0);
    const [reRenderDataTable, setRerenderDataTable] = useState(false);
    const [searchedData, setSearchedData] = useState(initialFilters);
    const [searchKeyForTable, setSearchKeyForTable] = useState(true);
    


    const searchFormik = useFormik({
    
        initialValues: initialFilters,
        validationSchema: validationSchema || undefined, // Only apply if passed
        enableReinitialize: true,
        onSubmit: (values) => {
            
            const refinedSearchdata = { ...values,...( serverSort ? { sort_order: searchedData?.sort_order, sort_key: searchedData?.sort_key}:{}) }
            fetchData(1, limit, refinedSearchdata);
            setSearchedData(refinedSearchdata);
            
            setPageNo(1)
            setSearchKeyForTable(prev=>!prev)
            
        }
    });

    const fetchData = async (pageno, limit, search) => {
        // const {clients,facility,partner} = search
        setLoading(true)
        fetchDataFunction(pageno, limit, search)((response) => {
            if (response?.status && response?.status_code == 200) {

                setData(response?.data);
                setPageNo(pageno)
                setLimit(limit);
                setTotalRows(response?.data?.count)
            }
            setLoading(false)
        })
    };

    const handlePageChange = (page) => {
        setPageNo(page);
        fetchData(page, limit, searchedData);
        
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        setLimit(newPerPage);
        setPageNo(1);
        await fetchData(1, newPerPage, searchedData);
        setLoading(false);
        handleResetDataTable();
        
    };

    const handleResetDataTable = () => {
        setRerenderDataTable(true);
        setTimeout(() => {
            setRerenderDataTable(false);
        }, 200);
    };

    const handleReset = (page=1) => {
        
        searchFormik.resetForm();
        setPageNo(1)
        setSearchedData(initialFilters);
        fetchData(1, limit, initialFilters);
    };

    const handleSearch = (values) => {
        fetchData(1, limit, values);
        setSearchedData(values);
    };

    //=====================|server side PageNAtion|====================

    const handleSort = (column, direction, key) => {


        // use this in table components
        // defaultSortAsc={ (searchedData?.sort_order ||" ").toUpperCase() === 'ASC' ?true :false}     // false = DESC , true = ASC
        // onSort={handleSort}
        // sortServer
//ServerSort =true to the useFilterHook



        const field =
            key && column[key]
                ? column[key]
                : column.sortField || column.selector;

        fetchData(pageNo, limit, {
            ...searchedData,
            sort_key: field,
            sort_order: (direction || "")
        });
        
        setSearchedData({
            ...searchedData,
            sort_key: field,
            sort_order: (direction || "")
        });
    }

    return {
        // Data states
        data,
        loading,
        pageNo,
        limit,
        totalRows,
        reRenderDataTable,
        searchedData,
        searchKeyForTable,

        // Formik instance
        searchFormik,

        // Handlers
        handlePageChange,
        handlePerRowsChange,
        handleResetDataTable,
        handleReset,
        handleSearch,
        fetchData,

        // Setters (if needed)
        setData,
        setLoading,
        setPageNo,
        setLimit,
        setTotalRows,
        setSearchedData,
        handleSort
    };
};

export default useFilter;